class HeroSlider {
  constructor(element) {
    this.container = element;
    this.slides = Array.from(element.querySelectorAll('.hero-slider__slide'));
    this.currentIndex = 0;
    this.autoplayInterval = null;
    this.intervalTime = parseInt(element.dataset.sliderInterval) || 3000;
    
    // Only initialize slider if there are multiple slides
    if (this.slides.length > 1) {
      this.init();
    }
  }

  init() {
    this.startAutoplay();
    
    // Pause autoplay when tab is not visible
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.stopAutoplay();
      } else {
        this.startAutoplay();
      }
    });
  }

  goToSlide(index) {
    if (index < 0 || index >= this.slides.length) return;
    
    const currentSlide = this.slides[this.currentIndex];
    const nextSlide = this.slides[index];
    
    // Remove active class from current slide
    currentSlide.classList.remove('hero-slider__slide--active');
    
    // Move current slide to the left (prev position)
    currentSlide.classList.add('hero-slider__slide--prev');
    
    // Remove hidden class from next slide if it has it
    nextSlide.classList.remove('hero-slider__slide--hidden');
    
    // Add active class to new slide (it will slide in from the right)
    nextSlide.classList.add('hero-slider__slide--active');
    
    // After transition completes, mark all previous slides as hidden (except current)
    setTimeout(() => {
      this.slides.forEach((slide, slideIndex) => {
        if (slideIndex !== index && !slide.classList.contains('hero-slider__slide--active')) {
          slide.classList.remove('hero-slider__slide--prev');
          slide.classList.add('hero-slider__slide--hidden');
        }
      });
    }, 600);
    
    // Update current index
    this.currentIndex = index;
    
    // Reset autoplay
    this.stopAutoplay();
    this.startAutoplay();
  }

  nextSlide() {
    const nextIndex = (this.currentIndex + 1) % this.slides.length;
    this.goToSlide(nextIndex);
  }

  startAutoplay() {
    if (this.autoplayInterval) return;
    
    this.autoplayInterval = setInterval(() => {
      this.nextSlide();
    }, this.intervalTime);
  }

  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }

  destroy() {
    this.stopAutoplay();
    // Remove event listeners if needed
  }
}

// Initialize sliders when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const heroSliders = document.querySelectorAll('.hero-slider');
  
  heroSliders.forEach(element => {
    new HeroSlider(element);
  });
});

// For Shopify theme editor
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const heroSlider = event.target.querySelector('.hero-slider');
    if (heroSlider) {
      new HeroSlider(heroSlider);
    }
  });
  
  document.addEventListener('shopify:section:unload', (event) => {
    const heroSlider = event.target.querySelector('.hero-slider');
    if (heroSlider) {
      // Clean up if needed
    }
  });
}
